import React from "react";
import "../../styles/about.scss";
//import { HireMe } from '../tools';
import { Link } from "react-router";
import { motion } from "framer-motion";
import { LayoutContainer } from "@common";
import { useGlobalContext } from "../../context";
import { Button } from "@components/ui";

export const About = () => {
  const { t } = useGlobalContext();

  return (
    <LayoutContainer className="min-h-[83vh] flex-1 ">
      <motion.div
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 1 }}
        exit={{ scaleY: 0 }}
        transition={{ duration: 0.3 }}
        className="flex flex-1 min-w-[100%]"
      >
        <section className="flex flex-1 w-full px-6">
          <div className="flex flex-1 flex-col justify-center text-center">
            <h2 className="text-4xl leading-tight font-bold text-gray-900 dark:text-white">
              {t("about.title")}
            </h2>
          </div>

          <ul className="info-about-section space-y-8 max-w-[85ch] mx-auto text-justify">
            <li className="text-[1.2em] leading-9 text-gray-700 dark:text-gray-300">
              {t("about.p-two")}
            </li>
            <li className="text-[1.2em] leading-9 text-gray-700 dark:text-gray-300">
              {t("about.p-three")}
            </li>
            <li className="text-[1.2em] leading-9 text-gray-700 dark:text-gray-300">
              {t("about.p-foor")}
            </li>

            <div className="flex justify-start sm:justify-start gap-4 mt-8">
              <Link to="/portfolio">
                <Button variant="secondary" className="gap-2 px-6 py-3">
                  {t("about.work-btn")}
                </Button>
              </Link>

              <Link to="/contact">
                <Button className="gap-2 px-6 py-3">{t("about.cv-btn")}</Button>
              </Link>
            </div>
          </ul>
        </section>

        {/* <HireMe /> */}
      </motion.div>
    </LayoutContainer>
  );
};
